export const getRandomBackgroundIndex = () => {
	const backgroundArray = ['bg1', 'bg2', 'bg3', 'bg4', 'bg5', 'bg6'];
	const randomIndex = Math.floor(Math.random() * backgroundArray.length);
	return backgroundArray[randomIndex];
};
